import { useEffect } from "react"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { deleteServiceRequest, getServiceRequest } from "../../redux/apiCalls"
// Styles
import {
   Container,
   GridWrapper,
   Main,
   Wrapper,
   StyledLink,
   StyledButton,
   StyledIcon,
   Action,
   TitleWrapper,
   Title,
   TitleButton,
} from "./ServiceRequestList.styles"

const ServiceRequestList = () => {
   const dispatch = useDispatch()
   const requests = useSelector((state) => state.service.requests)

   useEffect(() => {
      getServiceRequest(dispatch)
   }, [dispatch])

   const handleDelete = (id) => {
      deleteServiceRequest(id, dispatch)
   }

   const columns = [
      { field: "requestNumber", headerName: "ID", width: 120 },
      { field: "requestDate", headerName: "Date", width: 200 },
      { field: "userId", headerName: "User", width: 220 },
      {
         field: "sparePart",
         headerName: "Spare Part",
         width: 120,
      },
      {
         field: "productRef",
         headerName: "Product Ref",
         width: 130,
      },
      {
         field: "comments",
         headerName: "Comments",
         width: 120,
      },
      {
         field: "action",
         headerName: "Action",
         width: 150,
         renderCell: (params) => {
            return (
               <Action>
                  <StyledLink to={"/service/" + params.row._id}>
                     <StyledButton>Edit</StyledButton>
                  </StyledLink>
                  <StyledIcon>
                     <DeleteOutline
                        onClick={() => handleDelete(params.row._id)}
                        color="secondary"
                     />
                  </StyledIcon>
               </Action>
            )
         },
      },
   ]

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Service Requests List</Title>
                  <Link to="/newService">
                     <TitleButton>Create</TitleButton>
                  </Link>
               </TitleWrapper>
               <GridWrapper>
                  <DataGrid
                     rows={requests}
                     columns={columns}
                     getRowId={(row) => row._id}
                     disableSelectionOnClick
                     pageSize={8}
                     checkboxSelection
                     autoHeight
                  />
               </GridWrapper>
            </Main>
         </Container>
      </>
   )
}

export default ServiceRequestList
